import { gql } from '@apollo/client';
export const GET_DRIVE_OCCURRENCE_GUEST = gql `
  query getDriveOccurrenceGuestById($driveOccurrenceGuestId: Int!) {
    canx_get_drive_occurrence_guest(drive_occurrence_guest_id: $driveOccurrenceGuestId) {
      id
      from
      to
      status
      meeting {
        id
        name
        from
        to
        meeting_type
        meeting_status
        meeting_histories {
          from
          id
          to
        }
        workflow_candidate_step_id
      }
      pay_item {
        id
        status
        order_items {
          item_id
          order_id
          unit_price
          total_price
          quantity
          order {
            id
            status
            transactions {
              currency_code
              payment_id
              external_id
              type
              status
              total_amount
              invoices {
                invoice_number
                id
              }
            }
          }
        }
        eligible_refund_rule {
          timeframe
          refund_percent
          amount
        }
        drive_occurrence_guest {
          from
          id
          status
          to
        }
        eligible_reschedule_rule {
          fee_percent
          timeframe
          amount
        }
        sku {
          currency_code
          plan_type
          name
          refund_rules {
            refund_percent
            timeframe
            amount
          }
          reschedule_rules {
            fee_percent
            timeframe
            amount
          }
        }
      }
      drive_occurrence {
        start_date
        end_date
        status
        workflow_step_id
        drive_schedule_id
      }
      drive_schedule {
        id
        booking_start_date
        booking_end_date
        drive_type
        name
        start_date
        end_date
        status
        timezone
        location
        slot_capacity
        slot_duration
        step {
          id
          workflow {
            id
            workflow_type
          }
        }
      }
      instruction
      reschedule_instruction
      cancel_instruction
    }
  }
`;
export const GET_DRIVE_OCCURRENCE = gql `
  query getScheduleOccurrenceDrive($drive_schedule_id: Int!) {
    sch_drive_occurrence(
      where: { drive_schedule_id: { _eq: $drive_schedule_id }, status: { _eq: SCHEDULED } }
      order_by: { start_date: asc }
    ) {
      drive_schedule_id
      status
      end_date
      start_date
      id
    }
  }
`;
export const SCH_GET_DRIVE_SLOTS = gql `
  mutation getSchDriveSlots($driveOccGuestId: Int!, $from: timestamptz, $to: timestamptz) {
    sch_get_drive_slots(drive_occurrence_guest_id: $driveOccGuestId, from: $from, to: $to) {
      drive_occurrence_id
      from
      to
      drive_schedule_id
    }
  }
`;
export const CONFIRM_DRIVE_MEETING_SLOT = gql `
  mutation confirmDriveSlot($drive_id: Int!, $from: timestamptz!, $to: timestamptz!, $driveOccurrenceGuestId: Int) {
    sch_confirm_drive_slot(
      drive_occurrence_id: $drive_id
      from: $from
      to: $to
      drive_occurrence_guest_id: $driveOccurrenceGuestId
    ) {
      data
      error_message
      success
    }
  }
`;
export const ATX_BOOK_EXAM_SLOT = gql `
  mutation atxBookExamSlot(
    $workflow_candidate_step_id: Int!
    $drive_occurrence_id: Int!
    $from: timestamptz
    $to: timestamptz
  ) {
    atx_book_exam_slot(
      workflow_candidate_step_id: $workflow_candidate_step_id
      drive_occurrence_id: $drive_occurrence_id
      from: $from
      to: $to
    ) {
      drive_occurrence_guest_id
      workflow_candidate_step_id
      last_updated_at
    }
  }
`;
export const CANCEL_DRIVE_OCCURRENCE_GUEST = gql `
  mutation CancelDriveOccurrenceGuest($driveOccurrenceGuestId: Int!) {
    canx_cancel_drive_occurrence_guest(drive_occurrence_guest_id: $driveOccurrenceGuestId) {
      reason
      message
      drive_occurrence_guest {
        id
        to
        from
      }
      drive_schedule_id
      drive_occurrence_id
    }
  }
`;
export const SUBSCRIBE_DRIVE_LOBBY_MEETING = gql `
  subscription getDriveLobbyMeeting($drive_schedule_id: Int!) {
    sch_drive_lobby(where: { drive_schedule_id: { _eq: $drive_schedule_id } }) {
      drive_schedule {
        slot_capacity
        slot_duration
      }
      candidate_user_id
      drive_guest_sequence
      drive_occurrence_guest_id
      drive_occurrence_id
      drive_schedule_id
      meeting_id
      meeting {
        duration
        from
        meeting_status
        meeting_type
        meeting_participants {
          online_meeting_link
        }
      }
    }
  }
`;
export const SUBSCRIBE_DRIVE_OCCURRENCE_GUEST_TIMES = gql `
  subscription subscribeDriveOccurrenceGuestTimes($driveOccurrenceGuestId: Int!) {
    sch_drive_occurrence_guest(where: { id: { _eq: $driveOccurrenceGuestId } }) {
      status
      from
      to
    }
  }
`;
export const GET_HEART_BEAT = gql `
  query getLobbyHeartBeat($drive_occurrence_id: Int!) {
    sch_heart_beat(data: { drive_occurrence_id: $drive_occurrence_id }) {
      data {
        drive_occurrence_id
        last_active_time
      }
      error_message
      success
    }
  }
`;
export const NOTIFY_DRIVE_SCHEDULE = gql `
  mutation notifyDriveSchedule($drive_schedule_id: Int!, $is_notify: Boolean!) {
    sch_notify_drive_join(data: { drive_schedule_id: $drive_schedule_id, is_notify: $is_notify }) {
      error_message
      success
      data
    }
  }
`;
export const UPDATE_LOBBY_DRIVE_MEMBER_STATUS = gql `
  mutation updateDriveMemberStatus($drive_schedule_id: Int!, $drive_occurrence_id: Int!, $status: String!) {
    sch_update_drive_member_status(
      data: { drive_schedule_id: $drive_schedule_id, drive_occurrence_id: $drive_occurrence_id, status: $status }
    ) {
      data
      error_message
      success
    }
  }
`;
export default {
    GET_DRIVE_OCCURRENCE_GUEST,
    GET_DRIVE_OCCURRENCE,
    SCH_GET_DRIVE_SLOTS,
    CONFIRM_DRIVE_MEETING_SLOT,
    ATX_BOOK_EXAM_SLOT,
    CANCEL_DRIVE_OCCURRENCE_GUEST,
    SUBSCRIBE_DRIVE_LOBBY_MEETING,
    SUBSCRIBE_DRIVE_OCCURRENCE_GUEST_TIMES,
    GET_HEART_BEAT,
    UPDATE_LOBBY_DRIVE_MEMBER_STATUS,
    NOTIFY_DRIVE_SCHEDULE,
};
